<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2026-->

<div class="modal-header">
  <h3 class="modal-title">
    <i class="fa fa-star text-warning"></i>&nbsp;&nbsp;Unlock IPSAT 2.0 Archetype Report
  </h3>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<!-- Generating state: replaces the normal modal body while the backend is
     running the engine + content load + AI personalization (~15–30s). -->
<div class="modal-body text-center p-xl" *ngIf="isGeneratingReport">
  <i class="fa fa-magic fa-3x text-primary-2 m-b-md" style="animation: pulse 1.5s ease-in-out infinite;"></i>
  <h4 class="font-bold m-b-sm">Generating your personalized report…</h4>
  <p class="text-muted m-b-lg" style="max-width: 420px; margin-left: auto; margin-right: auto;">
    We're analyzing your archetype pattern and composing insights tailored to your
    IPSAT profile. This usually takes about 15 to 30 seconds.
  </p>
  <div class="progress" style="height: 6px; max-width: 300px; margin: 0 auto 16px;">
    <div class="progress-bar progress-bar-striped active" style="width: 100%;"></div>
  </div>
  <p class="text-muted text-sm">
    <i class="fa fa-info-circle"></i>&nbsp;Please don't close this window.
  </p>
  <style>
    @keyframes pulse {
      0%, 100% { opacity: 1; transform: scale(1); }
      50% { opacity: 0.7; transform: scale(1.08); }
    }
  </style>
</div>

<div class="modal-body" *ngIf="!isGeneratingReport">
  <div class="row">
    <div class="col-md-12">
      <div class="m-b-lg">
        <h5 class="text-primary-2">Discover Your Leadership Archetype</h5>
        <p>
          The IPSAT 2.0 Archetype Report provides a deeper analysis of your identity profile,
          revealing your primary and overlay archetypes. You'll learn:
        </p>
        <ul>
          <li><strong>Primary Archetype</strong> - Your dominant leadership pattern</li>
          <li><strong>Overlay Archetype</strong> - Your secondary influence style</li>
          <li><strong>Stress & Recovery Patterns</strong> - How you respond under pressure</li>
          <li><strong>Ideal Projects</strong> - Where you create the most value</li>
          <li><strong>Personalized Insights</strong> - Based on your unique IPSAT profile</li>
        </ul>
      </div>

      <!-- Pricing -->
      <div class="hpanel m-b-md" *ngIf="price">
        <div class="panel-body">
          <div class="row">
            <div class="col-sm-8">
              <h5>IPSAT 2.0 Archetype Report</h5>
              <p class="text-muted" *ngIf="appliedDiscount">
                <i class="fa fa-tag text-success"></i>&nbsp;
                Discount applied: <strong>{{ appliedDiscount }}</strong>
                <a href="javascript:void(0)" (click)="removeDiscount()" class="text-danger m-l-sm">
                  <i class="fa fa-times"></i> Remove
                </a>
              </p>
            </div>
            <div class="col-sm-4 text-right">
              <h3 class="font-bold text-success" *ngIf="price.currencyQuantity > 0">
                <app-nexleader-currency
                  [currencyCode]="price.currencyCode"
                  [currencyQuantity]="price.currencyQuantity">
                </app-nexleader-currency>
              </h3>
              <h3 class="font-bold text-success" *ngIf="price.currencyQuantity <= 0">
                FREE
              </h3>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading state -->
      <div class="text-center p-lg" *ngIf="isLoadingPrice">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <p class="m-t-sm">Loading price...</p>
      </div>

      <!-- Discount Code -->
      <div class="m-b-md" *ngIf="!appliedDiscount && price">
        <label class="control-label">Have a discount code?</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Enter discount code"
            [(ngModel)]="discountCode"
            (keyup.enter)="applyDiscount()"
          />
          <span class="input-group-btn">
            <button class="btn btn-default" type="button" (click)="applyDiscount()">
              Apply
            </button>
          </span>
        </div>
        <small class="text-danger" *ngIf="discountError">{{ discountError }}</small>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer" *ngIf="!isGeneratingReport">
  <button type="button" class="btn btn-default" (click)="cancel()" [disabled]="isProcessing">
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-success"
    (click)="purchase()"
    [disabled]="!price || isLoadingPrice || isProcessing"
  >
    <span *ngIf="!isProcessing">
      <i class="fa fa-lock"></i>&nbsp;&nbsp;
      <span *ngIf="price && price.currencyQuantity > 0">Purchase Report</span>
      <span *ngIf="price && price.currencyQuantity <= 0">Get Free Report</span>
    </span>
    <span *ngIf="isProcessing">
      <i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;Processing payment…
    </span>
  </button>
</div>
